// SupportShell — светлая обёртка для страниц /support, /support/my,
// /support/ticket/:id. Не используем общий Layout (он тёмный
// лендинг-стиль), не используем CabinetLayout (там сайдбар кабинета).
//
// Состав: компактная шапка с логотипом + кнопками «Кабинет» / «Войти»,
// светло-серый фон #f5f7fb (тот же что в кабинете), сам контент.
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "../../styles/support.css";

export default function SupportShell({ children }) {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="sup-shell">
      <header className="sup-shell__header">
        <button
          type="button"
          className="sup-shell__brand"
          onClick={() => navigate(isAuthenticated ? "/app" : "/")}
          title="На главную"
        >
          {/* Брендовый значок — inline SVG в духе A02.png Рублокса:
              синий rounded square + белый треугольник play. */}
          <span className="sup-shell__brand-mark" aria-hidden>
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <rect width="32" height="32" rx="8" fill="#3357ff" />
              <path d="M12 9.5v13l11-6.5-11-6.5z" fill="#fff" />
            </svg>
          </span>
          <span className="sup-shell__brand-text">Рублокс · Поддержка</span>
        </button>

        {/* Для авторизованных навигацию даёт меню кабинета (SupportPage
            обёрнут в CabinetChrome) + плавающая кнопка выхода — поэтому
            кнопки «Кабинет»/«Выйти» здесь не нужны. Гостям показываем
            «Войти»/«Регистрация». */}
        {!isAuthenticated && (
          <nav className="sup-shell__nav">
            <button type="button" className="sup-shell__nav-btn sup-shell__nav-btn--ghost"
                    onClick={() => navigate("/login")}>
              Войти
            </button>
            <button type="button" className="sup-shell__nav-btn"
                    onClick={() => navigate("/signup")}>
              Регистрация
            </button>
          </nav>
        )}
      </header>

      <main className="sup-shell__main">{children}</main>
    </div>
  );
}
